import ActivitiesApplicationRow from "./ActivitiesApplicationRow";

const ActivitiesApplicationTable = ({ actividades, search }) => {
  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>ID</th>
            <th>Actividad</th>
            <th>Talento</th>
            <th>Estado</th>
            <th className="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {actividades.map((actividad) => (
            <ActivitiesApplicationRow
              key={actividad.id}
              actividad={actividad}
              search={search}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ActivitiesApplicationTable;
